import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import * as classNames from 'classnames';
import { BubblingMethod } from './../../../../common/helpers/bubbling';

// Styles
const s = require('./Tooltip.css');
const closeIcon = require('./../../assets/cross-orange-sign.svg');

// Props
interface ITooltipProps {
    onClose?: () => void;
    style?: React.CSSProperties;
    className?: string | null;
    show: boolean;
    title: string;
    closeButtonLabel?: string;
}

// Component
@observer
export class Tooltip extends React.Component<ITooltipProps, {}> {
    static get defaultProps(): ITooltipProps {
        return {
            onClose: null,
            style: null,
            className: null,
            show: false,
            title: '',
            closeButtonLabel: ''
        };
    }

    constructor(props: ITooltipProps) {
        super(props);

        if (this.props.show === true) {
            this.showTooltip();
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.show && !nextProps.show) {
            this.frozenChildren =
                typeof this.props.children !== 'undefined' && this.props.children ? this.props.children : null;
        } else if ((!nextProps.show && !this.hiding) || (!this.props.show && !this.hiding) || this.none) {
            this.frozenChildren = null;
        }

        if (!this.props.show && nextProps.show) {
            this.showTooltip();
        } else if (this.props.show && !nextProps.show) {
            this.hideTooltip();
        }
    }

    private windowEvents: void[] = [];

    private frozenChildren: any = null;

    @observable private none: boolean = true;
    @observable private show: boolean = false;
    @observable private hiding: boolean = false;

    public render() {
        const { show, title, closeButtonLabel } = this.props;

        return (
            <div
                ref={this.referenceTooltipContainer}
                style={this.props.style}
                className={classNames(s.tooltip, this.props.className, {
                    [s.displayNone]: this.none,
                    [s.show]: this.show,
                    [s.hiding]: this.hiding
                })}
            >
                <div className={s.titlebar}>
                    <p className={s.title}>{title}</p>
                    <button className={s.closeButton} onClick={this.handleCloseButtonClick}>
                        <span>{closeButtonLabel}</span>
                        <img src={closeIcon} alt="" />
                    </button>
                </div>

                <div className={s.content}>
                    {(this.show && !this.none) || (this.hiding && this.frozenChildren !== null)
                        ? this.frozenChildren !== null
                          ? this.frozenChildren
                          : typeof this.props.children !== 'undefined' && this.props.children !== null
                            ? this.props.children
                            : null
                        : null}
                </div>
            </div>
        );
    }

    private tooltipContainer: HTMLDivElement = null;
    private referenceTooltipContainer = ref => (this.tooltipContainer = ref);

    private handleDocumentClick = (e: Event) => {
        if (this.tooltipContainer && BubblingMethod.isInsideOtherElement(e.target as HTMLElement, this.tooltipContainer)) {
            // Do nothing
        } else {
            this.hideTooltip();
        }
    };

    @action
    private showTooltip = () => {
        this.none = false;
        this.hiding = false;

        setTimeout(() => {
            this.show = true;
        }, 64);

        this.windowEvents.push(document.body.addEventListener('click', this.handleDocumentClick, false));
    };

    @action
    private hideTooltip = () => {
        this.show = false;
        this.hiding = true;

        setTimeout(() => {
            this.none = true;
            this.hiding = false;
        }, 400);

        if (this.props.onClose) {
            this.props.onClose();
        }

        this.windowEvents.map(ev => {
            document.body.removeEventListener('click', this.handleDocumentClick);
        });

        this.windowEvents = [];
    };

    private handleCloseButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.hideTooltip();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/popup/Tooltip.tsx